import { useState, useEffect } from 'react';

/**
 * useColorScheme()
 * Returns 'dark' or 'light' based on system preference.
 * Reactively updates if the user changes their OS setting.
 */
export function useColorScheme() {
  const [scheme, setScheme] = useState(() =>
    window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light'
  );

  useEffect(() => {
    const mq = window.matchMedia('(prefers-color-scheme: dark)');
    const handler = (e) => setScheme(e.matches ? 'dark' : 'light');
    mq.addEventListener('change', handler);
    return () => mq.removeEventListener('change', handler);
  }, []);

  return scheme;
}
